import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { IFilterDataItem } from "components/Filters/filtersOptions";
import { DAY_IN_MINUTES } from "utils/date-utils";
import { AccessTokenHelper } from "utils/token";
import {
  MAX_SLIDER_FILTER_VALUE,
  MIN_SLIDER_FILTER_VALUE
} from "./WorkOrdersFiltersDialog/filterOptions";

interface ITabsStatuses {
  isOpenTab: boolean;
  isAssignedTab: boolean;
  isCompleteTab: boolean;
  isClosedTab: boolean;
  isCanceledTab: boolean;
}

interface IUserPermissions {
  hasPermissionAssign: boolean;
  hasPermissionClose: boolean;
  hasPermissionComplete: boolean;
  hasPermissionReopen: boolean;
}

export enum ETimeFilterState {
  OPEN = "open",
  ASSIGNED = "assigned"
}

interface ITimeFilterValues {
  minutesOpenFrom: {
    value: number;
  };
  minutesOpenTo: {
    value: number;
  };
  minutesAssignedFrom: {
    value: number;
  };
  minutesAssignedTo: {
    value: number;
  };
}

export enum EPopoverType {
  ASSIGN = "ASSIGN",
  CLOSE = "CLOSE",
  COMPLETE = "COMPLETE",
  REOPEN = "REOPEN",
  REASSIGN = "REASSIGN",
  UNDO_COMPLETE = "UNDO COMPLETE"
}

export const getTabsStatuses = (
  activeTab: racehorse360.WorkOrderStatus
): ITabsStatuses => {
  const isOpenTab =
    activeTab === racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_OPEN;
  const isAssignedTab =
    activeTab === racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_ASSIGNED;
  const isCompleteTab =
    activeTab === racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_COMPLETE;
  const isClosedTab =
    activeTab === racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CLOSED;
  const isCanceledTab =
    activeTab === racehorse360.WorkOrderStatus.WORK_ORDER_STATUS_CANCELED;

  return {
    isOpenTab,
    isAssignedTab,
    isCompleteTab,
    isClosedTab,
    isCanceledTab
  };
};

export const getUserPermissions = (
  workOrder: racehorse360.IWorkOrder,
  currentUser: AccessTokenHelper
): IUserPermissions => {
  let hasPermissionAssign = false;
  let hasPermissionClose = false;
  let hasPermissionReopen = false;
  let hasPermissionComplete = false;

  if (
    workOrder?.facility.id &&
    currentUser.maintenanceFacilityIds.includes(workOrder.facility.id)
  ) {
    hasPermissionAssign = currentUser.isMaintenanceSupervisor;
    hasPermissionClose = currentUser.isMaintenanceSupervisor;
    hasPermissionReopen = currentUser.isMaintenanceSupervisor;
    hasPermissionComplete = currentUser.isMaintenance;
  }

  return {
    hasPermissionAssign,
    hasPermissionClose,
    hasPermissionComplete,
    hasPermissionReopen
  };
};

export const getFilterDateOnValue = (
  endDate: number
): racehorse360.IDateMatch => {
  if (!endDate) return null;

  return endDate === 1
    ? { exact: new Date().toISOString().slice(0, 10) }
    : {
        range: {
          relative: {
            startDate: {
              value: -Math.abs(endDate)
            },
            endDate: {
              value: 1
            }
          }
        }
      };
};

export const getFilterUsersIdsValue = (items: IFilterDataItem[]): string[] => {
  if (Array.isArray(items)) {
    return items.map((item: IFilterDataItem) => item.value);
  }

  return [];
};

export const getTimeFilterValues = (
  time: number[],
  state: ETimeFilterState
): Partial<ITimeFilterValues> => {
  const timeFromValue =
    time[0] === MIN_SLIDER_FILTER_VALUE
      ? null
      : { value: time[0] * DAY_IN_MINUTES };
  const timeToValue =
    time[1] === MAX_SLIDER_FILTER_VALUE
      ? null
      : { value: time[1] * DAY_IN_MINUTES };

  switch (state) {
    case ETimeFilterState.OPEN:
      return {
        minutesOpenFrom: timeFromValue,
        minutesOpenTo: timeToValue
      };
    case ETimeFilterState.ASSIGNED:
      return {
        minutesAssignedFrom: timeFromValue,
        minutesAssignedTo: timeToValue
      };
  }
};
